import React from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  ManageCommunication,
  PlanLevelCommunication,
  EmailLayout,
  ConfigureCommunication,
  CommunicationHistory,
  CommunicationHistoryInfo,
  Communication,
  CommunicationInfo,
  NewEmailLayout,
} from "../layouts";

import {
  ROUTES,
  MANAGE_COMMUNICATION_ROUTES,
  ApplicationRoute,
} from "../utils";

const menu = "communication",
  flow = "edit";
export const ManageCommunicationRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.PLAN_LEVEL_COMMUNICATION}`,
          `${MANAGE_COMMUNICATION_ROUTES.PLAN_LEVEL_COMMUNICATION}`,
        ]}
        component={PlanLevelCommunication}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT}`,
          `${MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT}`,
        ]}
        component={EmailLayout}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.CONFIGURE_COMMUNICATION}`,
          `${MANAGE_COMMUNICATION_ROUTES.CONFIGURE_COMMUNICATION}/:eventOrScheduleName?/:eventId?/:planId?/:configureCommunicationindex?`,
        ]}
        component={ConfigureCommunication}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY}`,
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY}`,
        ]}
        component={CommunicationHistory}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY_INFO}/:communicationNameId?`,
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY_INFO}/:flow(view)/:communicationNameId?`,
        ]}
        component={CommunicationHistoryInfo}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION}`,
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION}/:flow(add|edit|save)`,
        ]}
        component={Communication}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}/:communicationId?`,
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}/:flow(add|edit|save)/:communicationId?`,
          `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}/:flow(add|edit|save)/:communicationId?/:fromPage?`,
        ]}
        component={CommunicationInfo}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO}/:layoutId?`,
          `${MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO}/:flow(add|edit|save)/:layoutId?`,
        ]}
        component={NewEmailLayout}
      />
      <Redirect
        exact
        menu={menu}
        from={ROUTES.MANAGE_COMMUNICATION}
        to={MANAGE_COMMUNICATION_ROUTES.PLAN_LEVEL_COMMUNICATION}
      />
    </Switch>
  );
};
